import { render, staticRenderFns } from "./KT-MyPagesSettings.vue?vue&type=template&id=00045aa2&"
import script from "./KT-MyPagesSettings.vue?vue&type=script&lang=js&"
export * from "./KT-MyPagesSettings.vue?vue&type=script&lang=js&"
import style0 from "./KT-MyPagesSettings.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports